import { Component, effect } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TranslateModule } from '@ngx-translate/core'
import { CardModule } from 'primeng/card'
import { ButtonModule } from 'primeng/button'
import { AuthService } from '../../services/auth.service'
import { ResponsiveLogoComponent } from '../../components/commons/responsive-logo/responsive-logo.component'
import { UtilsService } from '../../services/utils/utils.service'
import { Router } from '@angular/router'

@Component({
  selector: 'app-login-page',
  imports: [
    CommonModule,
    TranslateModule,
    CardModule,
    ButtonModule,
    ResponsiveLogoComponent,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginPageComponent {
  loginError: string | null = null

  constructor(
    private authService: AuthService,
    private utilsService: UtilsService,
    private router: Router,
  ) {}

  async login() {
    this.authService.login()
  }

  effect = effect(() => {
    const isLoggedIn = this.authService.isLoggedIn()

    if (isLoggedIn) {
      this.router.navigate(['/'])
    }
  })

  ngOnInit() {
    this.utilsService.initPageTitle('LOGIN.TITLE')
  }
}
